// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover__title {\n  text-align: center;\n}\n.input145px .el-input {\n  width: 145px !important;\n}", ""]);
// Exports
module.exports = exports;
